module.exports = __webpack_public_path__ + "static/media/instagram.d4d26f6c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scss/icons/instagram.svg
// module id = 897
// module chunks = 0